import JobTags from ".";

export const jobTagsRoutes = () => [
  {
    path: "/admin/job-tags",
    component: JobTags,
    layout: "admin",
    routeType: "admin",
    title: "Jobs Management",
  },
];
